var map = {
	"./DrKevinOng.png": "b580",
	"./DrSharonLee.png": "e12f",
	"./IconBloodSugarControl.png": "5fe8",
	"./IconBloodSugarControl.svg": "5c89",
	"./IconDietConsultation.png": "6461",
	"./IconDietConsultation.svg": "9d54",
	"./IconMedicationTherapyManagement.png": "c751",
	"./IconMedicationTherapyManagement.svg": "f101",
	"./IconPre-&Post-NatalCare.png": "75e6",
	"./IconPre-&Post-NatalCare.svg": "2614",
	"./IconSkinConsultation.png": "b6bb",
	"./IconSkinConsultation.svg": "59a9",
	"./IconWomensHealth.svg": "abf5",
	"./IconWoundCare.png": "fda1",
	"./IconWoundCare.svg": "2449",
	"./KevinSharonCare.jpg": "6da1",
	"./LogoMedwell.png": "788a",
	"./LogoMedwellWhite.png": "4509",
	"./OurLocation.png": "0ce6",
	"./OurPeople.png": "49cd",
	"./OurPractice1.png": "847f",
	"./OurPractice2.png": "d4f6",
	"./blog/1.jpg": "9882",
	"./blog/Antimicrobial Resistance.jpg": "0c6d",
	"./blog/Blog1.png": "5b26",
	"./blog/Blog2.png": "883a",
	"./blog/Blog3.png": "bee9",
	"./blog/Childhood Obesity.jpg": "c28b",
	"./blog/Dispensing Separation.jpg": "5693",
	"./blog/E-cigarettes and Vapes are Not Aids for Smoking Cessation.jpg": "471f",
	"./blog/Erectile Dysfunction in Malaysian Men.jpg": "eeea",
	"./blog/Healthcare Collaboration, Not War Op-Ed.jpg": "5574",
	"./blog/It’s time to talk about sexual health.jpg": "55b8",
	"./blog/Medication Management during Ramadan.jpg": "5a26",
	"./blog/Medication Safety in Pregnancy and Lactation.jpg": "0d4b",
	"./blog/Medication Safety.jpg": "3acc",
	"./blog/Mental Health Illness is Not a Weakness.jpg": "4cb5",
	"./blog/Patient Counselling.jpg": "e835",
	"./blog/Pharmaceutical Compounding.jpg": "4a48",
	"./blog/Pharmacists and the Elderly in Malaysia.jpg": "960a",
	"./blog/Pharmacist’s Role in Immunization.jpg": "c8c0",
	"./blog/Polypharmacy.jpg": "962c",
	"./blog/Public Health.jpg": "85fd",
	"./blog/Shift from Management to Prevention of Diabetes.jpg": "e06e",
	"./blog/Smoking Cessation a Challenge in Malaysia.jpg": "75b4",
	"./blog/Telepharmacy.jpg": "1e4c",
	"./blog/The Role of a Pharmacist in Public Health.jpg": "d447",
	"./blog/The State of Disconnected Care in Malaysia.jpg": "b7d5",
	"./blog/The Utility of E-Prescribing System in Malaysia.jpg": "98ed",
	"./blog/Utilization of Health Information Technology in Malaysia.jpg": "9ee6",
	"./blog/What a Pharmacist Should Know About Pediatric Pharmacy.jpg": "21c3",
	"./blog/Women’s Health.jpg": "47bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";